import React, { Component } from 'react';
//import PresentationSingleRecording from 'pages/PKCreation/PresentationSingleRecording/Presentation';
//import PresentationRecordingPerSlide from 'pages/PKCreation/PresentationRecordingPerSlide/Presentation';
import {  user_access_level } from 'Api/Api';
// user_access_token,
// import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
//import Steps from 'pages/PKCreation/Tabs/Steps';
import axios from 'axios';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { withRouter } from 'react-router-dom';
//import sanitize from 'sanitize-filename';

import sanitize from 'sanitize-filename';

// Links of Description section
import "../style.css";
import { searchUrl, apiUrl, Category_list_Api, HeaderConfig, user_entity_uuid } from "Api/Api";
// , user_API
import { organization_user_access_level, user_account_level, org_friendly_url, presentation_Creation_API, myHeaders_Autorized, myHeaders_Auth_With_Cache_Control } from 'Api/Api'
import { massageFriendlyUrl, current_unix_stamp, get_current_unix_stamp } from "utils/Helper";
// , saveKey
// import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import MultiSelect from "components/MultiSelectSearch/MultiSelect";
// import Multisearch from "components/MultiSelectSearch/MultiSearch";
//import Button from 'components/Button/Button';
// import { slides_Creation_API } from 'Api/Api';
// import logo from "Assets/cloud-upload.png";
// import RUG from "react-upload-gallery";
import "react-upload-gallery/dist/style.css";
// Links of Audio
// import mic from "Assets/mic.png";
// import cloud from "Assets/cloud-upload.png";
import option from "Assets/Group 13.png";
// import option1 from "Assets/option1.png";
// Links of Presentation section
import { user_Status_Ver } from 'Api/Api'
// ,user_Status
// Links of PK success page
//import PKSuccess from 'pages/PKList/PkList';
import LegacyJSON from 'utils/LegacyArrays.json';
import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

let event_Name_Arr= [];
let my_Events = [];
let pkEvent = [];
let event_Picked;
//let slideImgPresentation=[];
let apiEventResArr=[]; // for event data from API
//let SlideTempArr = [];
//let SlideFinalPushTemp = [];
//let SlideArrData = []; // will hold slides from database
//let SlideDataPatch = [];
//let SlideImageArr = [];
//let SlideImageThumbnail = [];
let slideCoverArr=[]; // for the actual dropdown data
//let promiseCheck=[];

class PresentationDescription extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.state = {
          cover_image_data_array_buffer: null,
          cover_image_url: '',
          cover_image_file: '',
            allow_comments: 'all',
            public_private_selected_option: org_friendly_url ? 'private' : 'public',
            community_pk_event_option: '',
            community_pk_event_options: [],
            slide_count: 20,
            slide_length: 20,
            pk_format_selected_option: '20x20',
            pk_format_options: [],

            // the appropriate format option will be selected based on what sort of user is logged in and if they are in a workspace
            //  TODO: enforce at API level
            pk_format_options: {
                'normal_user': [
                    {
                        format: '20x20',
                        slide_count: 20,
                        slide_length: 20
                    },
                    {
                        format: '5x5',
                        slide_count: 5,
                        slide_length: 5
                    },
                    {
                        format: '10x10',
                        slide_count: 10,
                        slide_length: 10
                    },
                    {
                        format: '10x20',
                        slide_count: 10,
                        slide_length: 20
                    },
                    {
                        format: '1x20',
                        slide_count: 1,
                        slide_length: 20
                    },
                ],
                'private_user': [
                    {
                        format: '20x20',
                        slide_count: 20,
                        slide_length: 20
                    },
                    {
                        format: '5x5',
                        slide_count: 5,
                        slide_length: 5
                    },
                    {
                        format: '10x10',
                        slide_count: 10,
                        slide_length: 10
                    },
                    {
                        format: '10x20',
                        slide_count: 10,
                        slide_length: 20
                    },
                    {
                        format: '1x20',
                        slide_count: 1,
                        slide_length: 20
                    },
                ],
                'workspace_user': [
                    {
                        format: '20x20',
                        slide_count: 20,
                        slide_length: 20
                    },
                    {
                        format: '5x5',
                        slide_count: 5,
                        slide_length: 5
                    },
                    {
                        format: '10x10',
                        slide_count: 10,
                        slide_length: 10
                    },
                    {
                        format: '10x20',
                        slide_count: 10,
                        slide_length: 20
                    },
                    {
                        format: '1x20',
                        slide_count: 1,
                        slide_length: 20
                    },
                ]
            },

            cat_Arr: [],
            categories_text_array: [],
            pkTitle: "",
            touched: {},

            uploadedFileContents:[],
            pkOwnerCheck:true,

            step: 1,
            textarea: '',
            textareaError: '',
            eventdropdown: '',

            descriptionLoader: false,
            myEventsState: [],
            PKCreationPresentationId: null,
            pkFriendlyUrl: '',
            pkDescription: '',

            pkEvent_name:'',
            myEventsDefault:'None',
            validated: false,
            showComponent: false,
            Categories: [],
            Category_names: [],
            loading: true,
            FriendlyUrlStatus: 0,

            friendlyUrlCollision: true,
            pkTitleCollision: true,
            friendlyurl_title: '',
            apiCategoryRes:[],

            apiEvents:[],
            btnDisableValidate:true,

            slide_cover_index_changed: false,
            slide_cover_index: 0, // starting cover image index (order_integer - 1)
            pad_color: 'black', // starting pad_color
            pad_color_changed: false,
            ImageUploadLoader: false,
            images: [],
            SlideNumber: 0,
            FriendlyUrlNumber: 1,
            
            presentationId: '',
            savedImages: [], // on edit, this is the slides from the database before changes are done
            
            imageValidator: false,
            ImgPublishBtn:false,
            
            audioType: "upload",   
            pkAudio:'',
            stored_Cat:[], 
            
            allowed: true,
            audio_delay:0,
            language_abbreviation:'en-US',
            audioFileName:'',
            rugChangedCount: 0,
            slidesChanged: false,
            displayed_transcript: ''
        };
        this.default_slide_length = 20;
        this.default_slide_count = 20;

        const all_public_private_options = {
            workspace_admin: [
                {
                    value: "private",
                    display: "Team View"
                },
                {
                    value: "super_private",
                    display: "Private"
                },
                {
                    value: "public",
                    display: "Public"
                }
            ],
            workspace_normal: [
                {
                    value: "private",
                    display: "Team View"
                },
                {
                    value: "super_private",
                    display: "Private"
                }
            ],
            pro: [
                {
                    value: "public",
                    display: "Public"
                },
                {
                    value: "super_private",
                    display: "Private"
                }
            ],
            normal: [
                {
                    value: "public",
                    display: "Public"
                },
            ]
        }
        
        if (org_friendly_url && (organization_user_access_level === 'admin' || user_access_level === 'admin')) {
            this.state.public_private_options = all_public_private_options['workspace_admin'];
        } else if (org_friendly_url) {
            this.state.public_private_options = all_public_private_options['workspace_normal'];
        } else if (user_access_level === 'admin' || user_account_level === 'private') {
            this.state.public_private_options = all_public_private_options['pro'];
        } else {
            this.state.public_private_options = all_public_private_options['normal'];
        }

        // Description code
        this._onButtonClick = this._onButtonClick.bind(this);
        //this.focus = this.focus.bind(this);
        
        //this.create_or_edit = "";
        //if (this.props.presentation_uuid) {
        //    this.state.presentation_uuid = this.props.presentation_uuid;
        //}
        
        //this.usingMediaRecorder = typeof window.MediaRecorder !== 'undefined' ? true : false;
        //this.usingMediaRecorder = true;
        //console.log("usingMediaRecorder",this.usingMediaRecorder);
        
        this.workspace_base_url = "";
        //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        
        // determine PK format options based on user
        if (this.workspace_base_url) {
            this.state.pk_format_options = this.state.pk_format_options['workspace_user'];
        } else if (user_account_level === 'private') {
            this.state.pk_format_options = this.state.pk_format_options['private_user'];
        } else {
            this.state.pk_format_options = this.state.pk_format_options['normal_user'];
        }
        
        this.form_ref = React.createRef();
    }

    // Description
    /*
    focus() {
        this.setState({ FriendlyUrlStatus: 1 })
    }
    */

    _onButtonClick() {
        this.setState({
            showComponent: !this.state.showComponent
        });
    }

    myBlurHandler = (event) => {
        console.log("myBlurHandler",event.target.id,this.state[event.target.id]);
        this.setState({
            touched: {
                ...this.state.touched,
                [event.target.id]: true
                
            }
        });
    }

    myChangeHandler = (event) => {
        //console.log("myChangeHandler");
        if (event.target.id === "pkTitle") {
            this.setState({ pkTitle: event.target.value,pkFriendlyUrl:event.target.value });
        } else if (event.target.id === "pkDisplayedTranscript") {
            this.setState({ displayed_transcript:event.target.value });
        } else if (event.target.id === "pkDescription") {
            // for some reason, setting this field to something other than empty string in componentDidMount breaks checkValidity.
            //  set validity manually here
            let desc = document.getElementById('pkDescription');
            if (desc.value.length < 3) {
                desc.setCustomValidity('too short');
            } else {
                desc.setCustomValidity('');
            }
            //console.log("desc",desc.checkValidity(),desc.validity);
            this.setState({ pkDescription: event.target.value })
        } else if (event.target.id === "validationEventDropdown") {
            my_Events.forEach(function (item,index) {
                if (item.entity_name === event.target.value) {
                    event_Picked = [
                        {
                            "xref_data": {
                                "submitted_time": current_unix_stamp
                            },
                            "entity_uuid": item.entity_uuid
                        }
                    ]
                }
                event_Name_Arr[index] = item.entity_name 
            })
            pkEvent.push(event.target.value)
            this.setState({ pkEvent_name: pkEvent })
            
        }

    }

    handleSubmitDescriptionData = async (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            console.log("FORM INVALID");
            event.preventDefault();
            event.stopPropagation();
            this.setState({ validated: true })
            return;
        }
        
        console.log("FORM VALID",this.state.validated);
        
        this.setState({ descriptionLoader: true })
        event.preventDefault();
        const { pkTitle, pkDescription, pkFriendlyUrl,PKCreationPresentationId } = this.state;
        
        let presenter_entity_uuid = user_entity_uuid; // need switch here once event->presenter selection is added

        //let tmp_friendly_url = pkFriendlyUrl.toLowerCase().replace(/[\s.,&]/g, "-");  // this is now in massageFriendlyUrl
        let tmp_friendly_url = massageFriendlyUrl(pkFriendlyUrl);
        //tmp_friendly_url = sanitize(tmp_friendly_url); // this is now in massageFriendlyUrl
        
        // if no regular ascii characters after massaging, do something drastic and assign a generic friendly URL. API will make unique.
        if (tmp_friendly_url === '') {
          tmp_friendly_url = 'pechakucha-presentation';
        }
        
        // if there is a new cover image, upload it
        
        let DescriptionSec = {
            "entity_name": pkTitle,
            "description": pkDescription,
            "friendly_url": tmp_friendly_url,
            "searchterms":pkEvent,
            "events":event_Picked,
            slide_count:this.state.slide_count,
            slide_length: this.state.slide_length,
            displayed_transcript: this.state.displayed_transcript,
            allow_comments: this.state.allow_comments
        };
        
        if (this.props.presentation_uuid) {    
            // this is an edit - do a PATCH
            // API Patch Description starts
            console.log("PATCH'ing presentation");
            await axios.patch(`${presentation_Creation_API}/${this.props.presentation_uuid}`, DescriptionSec, myHeaders_Autorized);
            
            // did we change friendly_url? maybe the API altered it to be unique, so we have to ask the API for it
            let params = {
              attributes: ['friendly_url']
            }
            let presentation_response = await axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}`, { params, ...myHeaders_Auth_With_Cache_Control });
            
            // bust cache
            //axios.get(`${presentation_Creation_API}/${this.state.pkFriendlyUrl}`, myHeaders_Auth_With_Cache_Control);
            if (presentation_response.data.friendly_url && this.props.pk_info.status_code === 1) {
              await axios.get(`${presentation_Creation_API}/${presentation_response.data.friendly_url}`, myHeaders_Auth_With_Cache_Control);
            }
            
            if (this.state.cover_image_data_array_buffer) {
              await this.uploadCoverImage(this.props.presentation_uuid);
            }
            
            this.props.history.push(`${this.workspace_base_url}${local_routes.pkcreation}/${this.props.presentation_uuid}/slides`)
            //this.props.next();
            //this.setState({step: this.state.step + 1,descriptionLoader:false });
            // API Patch Description ends
        } else {
            // this is a create - do a POST
            console.log("POST'ing presentation");
            if (this.state.categories_text_array) {
                DescriptionSec.categories_text = this.state.categories_text_array;
            }
            if (this.state.cat_Arr.length > 0) {
                DescriptionSec.categories = this.state.cat_Arr;
            }
            let auto_publish = false;
            if (user_Status_Ver === "1") {
                auto_publish = true;
            }
            //DescriptionSec.public_status = 'public';
            //if (this.state.public_private_selected_option) {
                DescriptionSec.public_status = this.state.public_private_selected_option;    
            //}
            DescriptionSec.status_code = 4;
            DescriptionSec.auto_publish = auto_publish;
            
            DescriptionSec.users = [
                {
                    entity_uuid: presenter_entity_uuid,
                    xref_data: {
                        presenter_integer: 1,
                        creator_integer: 1,
                        entity_owner_integer: 1
                    }
                }
            ];
            if (this.props.source_info && this.props.source_info.presenter_entity_uuid && (this.props.source_info.presenter_entity_uuid !== presenter_entity_uuid)) {
              // this is coming from Manage Event
              DescriptionSec.users = [
                {
                    entity_uuid: presenter_entity_uuid,
                    xref_data: {
                        creator_integer: 1,
                        entity_owner_integer: 1
                    }
                },
                {
                    entity_uuid: this.props.source_info.presenter_entity_uuid,
                    xref_data: {
                        presenter_integer: 1,
                        entity_owner_integer: 2
                    }                  
                }
              ];
            } else {
              // normal
              DescriptionSec.users = [
                  {
                      entity_uuid: presenter_entity_uuid,
                      xref_data: {
                          presenter_integer: 1,
                          creator_integer: 1,
                          entity_owner_integer: 1
                      }
                  }
              ];
            }
            
            if (this.props.source_info && this.props.source_info.submit_event_uuid) {
              // this is coming from Manage Event, or some other community PK event-related page (eg /getonwithit)
              DescriptionSec.events = [
                {
                  entity_uuid: this.props.source_info.submit_event_uuid,
                  xref_data: {
                    submitted_time: get_current_unix_stamp()
                  }
                }
              ];              
            }
            
            DescriptionSec.current_slide_count = 0; // this is just an indicator for My PKs to know if we have slides or not
            
            console.log("POST",DescriptionSec);
            /*
            // community PK selection done on PK List page
            console.log("POST",this.state.pk_format_selected_option,this.state.community_pk_event_options,this.state.community_pk_event_option);
            
            if (this.state.pk_format_selected_option === this.state.community_pk_option_index && this.state.community_pk_event_options[this.state.community_pk_event_option]) {
                DescriptionSec.events = [
                    {
                        entity_uuid: this.state.community_pk_event_options[this.state.community_pk_event_option].entity_uuid,
                        xref_data: {
                            submitted_time: Math.floor(new Date().getTime() / 1000)
                        }
                    }
                ];
            }
            */
            
            let post_response = await axios.post(`${apiUrl}presentations`, DescriptionSec, myHeaders_Autorized);
            
            if (this.state.cover_image_data_array_buffer) {
              await this.uploadCoverImage(post_response.data.entity_uuid);
            }
            
            
            this.props.history.push(`${this.workspace_base_url}${local_routes.pkcreation}/${post_response.data.entity_uuid}/slides`);
            //this.props.next();
        }
    };


    // Multi Select categories Method handler
    multiSearchSelectDataMet = (add_Cat,remove_Cat,store_Cat) => {
        if (!this.props.presentation_uuid) {
            // CREATE PK
            // get categories_text field
            let categories_text_array = [];
            let cat_Arr = [];
            for (let cat_obj of store_Cat) {
                categories_text_array.push(cat_obj.entity_name);
                let tmp_cat_obj = {
                    entity_uuid: cat_obj.entity_uuid,
                    xref_data: {
                        added_time: current_unix_stamp
                    }
                }
                cat_Arr.push(tmp_cat_obj);
            }
            //cat_Name_Arr = categories_text_array;
    
            this.setState({stored_Cat:store_Cat, cat_Arr, categories_text_array });
        } else {
            // EDIT PK
            // get categories_text field
            let categories_text_array = [];
            let cat_Arr = [];
            for (let cat_obj of store_Cat) {
              categories_text_array.push(cat_obj.entity_name);
              let tmp_cat_obj = {
                  entity_uuid: cat_obj.entity_uuid,
                  xref_data: {
                      added_time: current_unix_stamp
                  }
              }
              cat_Arr.push(tmp_cat_obj);
            }
            this.setState({stored_Cat:store_Cat, cat_Arr, categories_text_array});
            
            // add_Cat will call PATCH /rest/presentations/<presentation_uuid>
            for (let cat_obj of add_Cat) {
                let patch_data = {
                    categories_text: categories_text_array,
                    categories: [
                        {
                            entity_uuid:cat_obj.entity_uuid,
                            xref_data: {
                                added_time: current_unix_stamp
                            }
                        }
                    ]
                }
                axios.patch(`${presentation_Creation_API}/${this.props.presentation_uuid}`, JSON.stringify(patch_data));
            }
            
            // remove_Cat will call DELETE /rest/presentations/<presentation_uuid>/categories/<category_uuid>
            for (let cat_obj of remove_Cat) {
                axios.delete(`${presentation_Creation_API}/${this.props.presentation_uuid}/categories/${cat_obj.entity_uuid}`);
                let patch_data = {
                    categories_text: categories_text_array
                }
                axios.patch(`${presentation_Creation_API}/${this.props.presentation_uuid}`, JSON.stringify(patch_data));            
            }
            
        }
    }

    APICalls = async () => {
        // JBB presentation_uuid is required here for edit
        let new_state = {...this.state};
        if (this.props.presentation_uuid) {
            
            let attributes_array = [
                'entity_name',
                'friendly_url',
                'description',
                'slide_count',
                'slide_length',
                'public_status',
                'displayed_transcript',
                'allow_comments',
                'image_url',
                'pad_color'
            ];
            
            try {
                let [presentationRes, userCategoriesRes, allCatsRes, community_pk_events_response, presentation_events_response] = await Promise.all([
                    //axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}`, myHeaders_Auth_With_Cache_Control),
                    axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}?attributes_array=${encodeURIComponent(JSON.stringify(attributes_array))}`, myHeaders_Auth_With_Cache_Control),
                    axios.get(`${presentation_Creation_API}/${this.props.presentation_uuid}/categories`, myHeaders_Auth_With_Cache_Control),
                    axios.get(Category_list_Api, HeaderConfig),
                    axios.get(`${searchUrl}eventsearch?event_type=community_pk`),
                    axios.get(`${apiUrl}presentations/${this.props.presentation_uuid}/events`,myHeaders_Auth_With_Cache_Control)
                ]);

                if (community_pk_events_response.data) {
                    let events_raw = community_pk_events_response.data.search_query_results.map((data) => data.entity_info);
                    //console.log("EVENTS",events_raw);
                    new_state.community_pk_event_options = events_raw;
                }
                
                if (presentation_events_response.data && presentation_events_response.data.length > 0 && new_state.community_pk_event_options) {
                    let community_pk_event_option = new_state.community_pk_event_options.findIndex(item => item.entity_uuid === presentation_events_response.data[0].entity_uuid);
                    if (community_pk_event_option >= 0) {
                        new_state.community_pk_event_option = community_pk_event_option;
                    }
                }

                let storedCatTempArr=[];
                let tmp_presentation_cats_obj = {};
                //let cover_image_url = "";
                if (presentationRes.data) {
                    let resData = presentationRes.data;
                    
                    // get simple audio file name
                    let audioFileName = "";
                    if (resData.audio_url) {
                        let tmp_array = resData.audio_url.split('/');
                        audioFileName = tmp_array[tmp_array.length-1];
                    }
                    /*
                    let tmp_slidesChanged = false; // trick to force video creation/recreation if there is no video URL
                    if (!resData.presentation_video_url) {
                        tmp_slidesChanged = true;
                    }
                    */
                    let slide_count = this.default_slide_count;
                    let slide_length = this.default_slide_length;
                    if (resData.slide_count) {
                        slide_count = resData.slide_count;
                    }
                    if (resData.slide_length) {
                        slide_length = resData.slide_length;
                    }
                    let pk_format_selected_option = this.state.pk_format_options.findIndex(item => (item.slide_count === slide_count && item.slide_length === slide_length));
                    //= slide_count+'x'+slide_length;
                    
                    /*
                    if (new_state.community_pk_event_option !== '') {
                        pk_format_selected_option = this.state.community_pk_option_index;
                    } else {
                        //console.log("HEY");
                        pk_format_selected_option = this.state.pk_format_options.findIndex(item => (!item.format.startsWith('Community') && item.slide_count === slide_count && item.slide_length === slide_length));
                        //console.log("HEY",pk_format_selected_option);
                        
                    }
                    */
                    //console.log("YO",new_state.community_pk_event_option,pk_format_selected_option);
                    
                    //if ()
                    let cover_image_url = '';
                    if (resData.image_url) {
                      let slide_dimensions = '480x270';
                      let image_mod_string = "padblack_noborder_"+slide_dimensions;
                      let array = resData.image_url.split("/");
                      if (resData.pad_color) {
                          image_mod_string = "pad"+new_state.pad_color+"_noborder_"+slide_dimensions;
                      }
                      cover_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/${image_mod_string}/${array[5]}`;
                    }
                    
                    new_state = {
                        ...new_state,
                        cover_image_url,
                        slide_count,
                        slide_length,
                        pk_format_selected_option,
                        pkTitle: resData.entity_name,
                        pkFriendlyUrl: resData.friendly_url,
                        pkDescription: resData['description'],
                        PKCreationPresentationId: this.props.presentation_uuid,
                        displayed_transcript: resData.displayed_transcript || '',
                        allow_comments: resData.allow_comments || 'all'
                        
                        //pkAudio:resData.audio_url,
                        //audioFileName,
                        //audio_delay:resData.audio_delay,
                        //language_abbreviation:resData.language_abbreviation,

                        //cover_image_url:resData.image_url,
                        
                        //slidesChanged: true                        
                    }
                    /*
                    this.setState({
                        slide_count,
                        slide_length,
                        pk_format_selected_option,
                        pkTitle: resData.entity_name,
                        pkFriendlyUrl: resData.friendly_url,
                        pkDescription: resData['description'],
                        //pkDescription: '',
                        PKCreationPresentationId: resData.entity_uuid,
                        pkAudio:resData.audio_url,
                        audioFileName,
                        audio_delay:resData.audio_delay,
                        language_abbreviation:resData.language_abbreviation,
                        //pad_color:resData.pad_color,
                        cover_image_url:resData.image_url,
                        slidesChanged: true
                    });
                    */
                    let padCol = resData.pad_color;
                    //console.log("API resData",resData);
                    //console.log("API padCol",padCol);
                    if (padCol) {
                        new_state.pad_color = padCol;
                        //this.setState({ pad_color: padCol });
                    }
                    //cover_image_url = presentationRes.data.image_url;
                }
                
                if (userCategoriesRes.data) {
                    // apiCategoryRes
                    //let apiCatResArr=[];
                    userCategoriesRes.data.forEach((item,index)=>{
                        //apiCatResArr.push(item)
                        let label = item.entity_name;
                        //if (item.entity_name.startsWith('#')) {
                        //  label = item.entity_name.substring(1);
                        //}
                        //storedCatTempArr[index]= { value: index, label, entity_uuid: item.entity_uuid, entity_name: item.entity_name };
                        storedCatTempArr[index]= { value: item.entity_uuid, label, entity_uuid: item.entity_uuid, entity_name: item.entity_name };
                        tmp_presentation_cats_obj[item.entity_uuid] = true;
                    });
                    //this.setState({apiCategories:storedCatTempArr,stored_Cat:storedCatTempArr});
                    new_state.stored_Cat = storedCatTempArr;
                    //this.setState({stored_Cat:storedCatTempArr});
                    if (storedCatTempArr.length > 0 ) {
                        new_state.showComponent = true;
                        //this.setState({showComponent:true});
                    }
                }

                if (allCatsRes.data) {
                    let Cat_Res = [];
                    let Cat_Res_Arr = [];let changedCatTempArr=[];

                    Cat_Res = allCatsRes.data.entities;
                    Cat_Res.forEach(function (element,index) {
                        Cat_Res_Arr.push(element.entity_name);
                        //if (!tmp_presentation_cats_obj[element.entity_uuid]) {
                            let label = element.entity_name;
                            //if (element.entity_name.startsWith('#')) {
                            //  label = element.entity_name.substring(1);
                            //}

                            //changedCatTempArr[index]= { value: index, label, entity_uuid: element.entity_uuid, entity_name: element.entity_name };
                            changedCatTempArr[index]= { value: element.entity_uuid, label, entity_uuid: element.entity_uuid, entity_name: element.entity_name };
                        //}
                    });
                    new_state.Categories = Cat_Res;
                    new_state.Category_names = Cat_Res_Arr;
                    new_state.Category_keys = changedCatTempArr;
                    
                    /*
                    this.setState({
                        Categories: Cat_Res,
                        Category_names: Cat_Res_Arr,
                        Category_keys:changedCatTempArr,
                        loading: false
                    });
                    */
                }
            } catch (err) {
                // standard resolution
            }
        } else {
            // brand new PK
            try {
                let [allCatsRes,community_pk_events_response] = await Promise.all([
                    axios.get(Category_list_Api, HeaderConfig),
                    axios.get(`${searchUrl}eventsearch?event_type=community_pk`),
                ]);
                
                if (community_pk_events_response.data) {
                    let events_raw = community_pk_events_response.data.search_query_results.map((data) => data.entity_info);
                    //console.log("EVENTS",events_raw);
                    new_state.community_pk_event_options = events_raw;
                    new_state.community_pk_event_option = 0;
                }
                
                let tmp_presentation_cats_obj = {};
                if (allCatsRes.data) {
                    let Cat_Res = [];
                    let Cat_Res_Arr = [];
                    let changedCatTempArr = [];
                    let storedCatTempArr = [];
                    let categories_text_array = [];
                    let cat_Arr = [];

                    Cat_Res = allCatsRes.data.entities;
                    //console.log("HMMMM0",this.props.source_info.category_friendly_url_array, Cat_Res.length);
                    Cat_Res.forEach((element,index) => {
                        //console.log("HMMMM0.1",this.props.source_info.category_friendly_url_array);
                        Cat_Res_Arr.push(element.entity_name);
                        if (!tmp_presentation_cats_obj[element.entity_uuid]) {
                          changedCatTempArr[index]= { value: index, label: element.entity_name, entity_uuid: element.entity_uuid, entity_name: element.entity_name };
                        }
                        
                        if (this.props.source_info && this.props.source_info.category_friendly_url_array) {
                          //console.log("HMMMM1",this.props.source_info.category_friendly_url_array,element.friendly_url);
                          if (this.props.source_info.category_friendly_url_array.includes(element.friendly_url)) {
                            // we want to automagically select this category!
                            //console.log("HMMMM2",element.friendly_url);
                            let label = element.entity_name;
                            categories_text_array.push(element.entity_name);
                            cat_Arr.push({
                              entity_uuid: element.entity_uuid,
                              xref_data: {
                                  added_time: current_unix_stamp
                              }
                            });
                            storedCatTempArr[index]= { value: element.entity_uuid, label, entity_uuid: element.entity_uuid, entity_name: element.entity_name };
                          }
                        }
                    });
                    //console.log("YOOO",storedCatTempArr);
                    //new_state.stored_Cat = storedCatTempArr;
                    //if (storedCatTempArr.length > 0 ) {
                    //  new_state.showComponent = true;
                    //}                  

                    new_state = {
                        ...new_state,
                        pkTitle: '',
                        pkDescription: '',
                        stored_Cat: storedCatTempArr,
                        Categories: Cat_Res,
                        Category_names: Cat_Res_Arr,
                        Category_keys: changedCatTempArr,
                        showComponent: storedCatTempArr.length > 0 ? true : false,
                        cat_Arr,
                        categories_text_array,
                        pk_format_selected_option: '20x20',
                        allow_comments:'all'
                    };
                    /*
                    this.setState({
                        pkTitle: '',
                        pkDescription: '',
                        stored_Cat: [],
                        Categories: Cat_Res,
                        Category_names: Cat_Res_Arr,
                        Category_keys:changedCatTempArr,
                        showComponent:false,
                        loading: false,
                        pk_format_selected_option: '20x20'
                    });
                    */
                }         
            } catch (err) {
                // standard resolution
            }
            
        }
        slideCoverArr = LegacyJSON.slideCoverImage['PkCoverImg'];    
        new_state.loading = false;
        this.setState(new_state);
    }

    
    componentDidUpdate (prevProps) {
        //console.log("YO",prevProps,this.props);
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }
    
    routeChanged () {
        console.log("routeChanged - PresentationDesc");
        if (!this.props.match.params.otherpage) {
            // resetting to a fresh create PK
            this.APICalls();
        }
        //this.APICalls();
        //this.APIPromises();
    }

    componentDidMount = async function () {
        await this.APICalls();
    }

    /*
    handleOnChange(e) {
        this.setState({ [e.target.id]: e.target.value })
    }
    handleColorChange = (e) => {
        //this.setState({ slideBG: e.target.value }) // this should be black or white
        //console.log("handleColorChange",e);
        this.setState({ pad_color_changed: true, pad_color: e.target.value }) // this should be black or white
    }
    handleCoverSlide=(e)=>{
        //this.setState({slideCoverNum:e.target.value}); // this should be 0..19
        this.setState({ slide_cover_index_changed: true, slide_cover_index:e.target.value}); // this should be 0..19
    }
    handleOnCheck(e) {
        this.setState({ [e.target.id]: !this.state.terms })
    }
    */

    handleCommunityPk = (e) => {
        //this.setState({slideCoverNum:e.target.value}); // this should be 0..19
        //let [slide_count,slide_length] = e.target.value.split('x');
        console.log("handleCommunityPk",e.target.value);
        this.setState({
            community_pk_event_option: parseInt(e.target.value),
            //slide_count,
            //slide_length
        }); // this should be 0..19
    }

   handlePublicPrivate = (e) => {
        console.log("handlePublicPrivate",e.target.value);
        this.setState({
            public_private_selected_option: e.target.value
        });
    }

    handleAllowComments = (e) => {
        console.log("handleAllowComments",e.target.value);
        this.setState({
            allow_comments: e.target.value
        });
    }
    
    handlePkFormat = (e) => {
        //this.setState({slideCoverNum:e.target.value}); // this should be 0..19
        //let [slide_count,slide_length] = e.target.value.split('x');
        let slide_count = this.state.pk_format_options[e.target.value].slide_count;
        let slide_length = this.state.pk_format_options[e.target.value].slide_length;
        console.log("handlePkFormat",e.target.value,slide_count,slide_length);
        this.setState({
            pk_format_selected_option: parseInt(e.target.value),
            slide_count,
            slide_length
        }); // this should be 0..19
    }

    handleCancel = async () => {
        let next_page = `${this.workspace_base_url}${local_routes.pklist}`;
        console.log("PK Create handleCancel",this.props);
        if (this.props.source_info && this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }

    uploadCoverImage = async (presentation_uuid) => {
      console.log('uploadCoverImage');
      //return;
      //this.setState({
      //  loading: true
      //});
      let params = {
        asset_type: 'image',
        filename: this.state.cover_image_file
      };
      let asset_upload_data = await axios.post(`${apiUrl}presentations/${presentation_uuid}/getUploadSignedUrl`, {}, { params });
      //let asset_length_bytes = this.state.leaf_asset_data.byteLength;
      const config = {
        headers: { "Content-Type": asset_upload_data.data.content_type },
        //onUploadProgress: (progressEvent) => {
        //  let upload_percent = Math.floor(progressEvent.loaded / asset_length_bytes * 100);
        //  this.setState({
        //    message: 'Uploaded '+upload_percent+'%'
        //  });
        //}
      };
      let uploadUrl = asset_upload_data.data.upload_url;
      //tmp_leaf_asset_url = asset_upload_data.data.asset_url;
      await axios.put(uploadUrl, this.state.cover_image_data_array_buffer, config);
      
      /*
      params = {
        preserve_ppt_overlay: true
      };
      await axios.post(`${apiUrl}presentations/${this.props.presentation_uuid}/pptxToSlides`, {}, { params });

      // now kickoff new slides_zip and pptx generation
      params = {
        trigger_create_presentation_slides_zip: true,
        trigger_create_presentation_pptx: true
      }
      await axios.patch(`${apiUrl}presentations/${this.props.presentation_uuid}`, params, myHeaders_Autorized);
      
      window.location.reload();
      */
    }

    onChangeCoverImageFile = async (event) => {
      console.log('onChangeCoverImageFile',event.target.files);
      if (event.target.files[0]) {
        let file_name = sanitize(event.target.files[0].name).replace(/[&\s]/g, '_').toLowerCase();
        
        // for saving to API
        let asset_data_array_buffer_promise = new Promise(resolve => {
          let reader = new FileReader();
          reader.readAsArrayBuffer(event.target.files[0]);
          reader.onload = () => resolve(reader.result);
        });
        
        // for displaying preview
        let asset_data_url_promise = new Promise(resolve => {
          let reader = new FileReader();
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = () => resolve(reader.result);
        });
        
        let [cover_image_data_array_buffer,cover_image_url] = await Promise.all([asset_data_array_buffer_promise,asset_data_url_promise]);
        
        this.setState({
          cover_image_file: file_name,
          cover_image_data_array_buffer,
          cover_image_url
        });
      }
    }
    
    render() {
        const { allowed,descriptionLoader,ImgPublishBtn,ImageUploadLoader, pkTitleCollision, imageValidator, savedImages } = this.state;
        
        //console.log("RENDER PresentationDesc",this.props.presentation_uuid);
        if (this.state.loading === true) {
            return (
                <ActivityIndicator theme="spinner" />
            )
        }

        return (
            <div>
                <div className="descript-section form-card">
                    <Row className="row-reverse">
                        <Col lg={6}>
                            <Form
                                id="main-form"
                                ref={this.form_ref}
                                noValidate
                                validated={this.state.validated}
                                onSubmit={this.handleSubmitDescriptionData}
                            >
                                <Form.Row>
                                    <Form.Group as={Col} md="12" controlId="pkTitle">
                                        <Form.Label>TITLE</Form.Label>
                                        <Form.Control
                                            required
                                            pattern=".{3,}"
                                            maxLength={120}
                                            type="text"
                                            //name="pkTitle"
                                            value={this.state.pkTitle}
                                            onChange={this.myChangeHandler}
                                            onBlur={this.myBlurHandler}
                                            placeholder="Add a short, clear name"
                                            isInvalid={this.state.touched.pkTitle && this.state.pkTitle.length < 3}
                                            //isInvalid={this.state.touched.pkTitle && this.state.pkTitle.length < 3}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Please enter a valid title between 3 and 120 characters long<br/>
                                            
                                        </Form.Control.Feedback>
                                        {
                                            pkTitleCollision === false ?
                                                <p className="PKTitleCollision">Sorry, PKTitle already exists. Enter different name</p>
                                                :
                                                null
                                        }
                                    </Form.Group>
                                </Form.Row>
                                {/* <Form.Row>
                                    <Form.Group as={Col} md="12" controlId="validationFriendlyUrl">
                                        <Form.Label>FRIENDLY URL</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            disabled="true"
                                            value={this.state.pkFriendlyUrl}
                                            onChange={this.myChangeHandler}
                                            placeholder="Friendly Url"
                                        />
                                        {
                                            friendlyUrlCollision === false ?
                                                <p className="PKTitleCollision">Sorry, Friendly Url already exists. Enter different name</p>
                                                :
                                                null
                                        }
                                    </Form.Group>
                                </Form.Row> */}
                                <Form.Group controlId="pkDescription">
                                    <Form.Label>DESCRIPTION</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        value={this.state.pkDescription}
                                        onChange={this.myChangeHandler}
                                        onBlur={this.myBlurHandler}
                                        placeholder="Write 2-4 sentences that describe your PK with enough detail that anyone who sees this description will understand what's being presented."
                                        rows="3"
                                        required
                                        pattern=".{3,4000}"
                                        maxLength="4000"
                                        isValid={!this.state.touched.pkDescription || this.state.pkDescription.length >= 3}
                                        isInvalid={this.state.touched.pkDescription && this.state.pkDescription.length < 3}
                                        //isInvalid={this.state.touched.pkDescription && this.state.pkDescription.length < 3}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a description between 3 and 4000 characters long
                                    </Form.Control.Feedback>
                                </Form.Group>
                                
                                <React.Fragment>
                                    <Form.Group controlId="pkFormat">
                                        <Form.Label>PK FORMAT (number of slides, seconds per slide)</Form.Label>
                                        <Form.Control
                                            as="select"
                                            disabled={this.props.presentation_uuid !== undefined}
                                            required
                                            value={this.state.pk_format_selected_option}
                                            onChange={this.handlePkFormat}
                                        >
                                            {
                                                this.state.pk_format_options.map((item,i)=>
                                                (
                                                    <option key={i} value={i}>{item.format}</option>
                                                ))
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </React.Fragment>
                                    <Form.Group controlId="allow_comments">
                                        <Form.Label>Allow/Show Comments</Form.Label>
                                        <Form.Control
                                            as="select"
                                            //disabled={this.props.presentation_uuid !== undefined}
                                            required
                                            value={this.state.allow_comments}
                                            onChange={this.handleAllowComments}
                                        >
                                            <option value='all'>Yes (comments require approval)</option>
                                            <option value='none'>No</option>
                                        </Form.Control>
                                    </Form.Group>

                                { (this.props.presentation_uuid === undefined && (user_access_level === 'admin' || this.workspace_base_url || user_account_level === 'private')) &&
                                    <React.Fragment>
                                        <Form.Group controlId="pkPulicStatus">
                                            <Form.Label>PUBLIC / PRIVATE</Form.Label>
                                            <Form.Control
                                                as="select"
                                                //disabled={this.props.presentation_uuid !== undefined}
                                                required
                                                value={this.state.public_private_selected_option}
                                                onChange={this.handlePublicPrivate}
                                            >
                                            {
                                                this.state.public_private_options.map((item,index) => 
                                                    <option key={index} value={item.value}>{item['display']}</option>
                                                )
                                            }
                                            </Form.Control>
                                        </Form.Group>
                                    </React.Fragment>
                                }



                                
                                {/*
                                <Form.Group controlId="validationEventDropdown" style={{ display: this.state.myEventsState.length > 0 && user_Status === 1 ? 'flex' : 'none' }}>
                                    <div className="form-dropdown">
                                        <Form.Label>EVENT</Form.Label>
                                        
                                        <Form.Control
                                            as="select"
                                            //value={apiEvents} 
                                            onChange={this.myChangeHandler}
                                        >
                                            <option>{this.state.myEventsDefault}</option>
                                            {
                                                this.state.myEventsState.map((item) =>
                                                    <option key={item.entity_uuid}>{item.entity_name}</option>
                                                )}
                                                
                                        </Form.Control>
                                    </div>
                                </Form.Group>
                                */}


                                
                                { this.props.presentation_uuid &&
                                    <React.Fragment>
                                        <Form.Group controlId="pkDisplayedTranscript">
                                            <Form.Label>TRANSCRIPT</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                value={this.state.displayed_transcript}
                                                onChange={this.myChangeHandler}
                                                onBlur={this.myBlurHandler}
                                                //placeholder="Write 2-4 sentences that describe your PK with enough detail that anyone who sees this description will understand what's being presented."
                                                rows="10"
                                                //required
                                                //pattern=".{3,}"
                                                minLength="3"
                                                //maxLength="4000"
                                                //isValid={!this.state.touched.pkDescription || this.state.pkDescription.length >= 3}
                                                //isInvalid={this.state.touched.pkDescription && this.state.pkDescription.length < 3}
                                                
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter a description at least 3 characters long
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </React.Fragment>
                                }

                                {!this.workspace_base_url &&
                                    <div className="pick-categories">
                                        <label>CATEGORIES</label>
                                        <div className="pick-categories-body">
                                            {/* <h5>ART & DESIGN</h5> */}
                                            <div>
                                                <h6 onClick={this._onButtonClick} style={{ paddingRight: "3px" }}>+</h6>
                                                {this.state.showComponent ? (
                                                    <MultiSelect
                                                        theme={this.context.theme}
                                                        component_type="category"
                                                        Categories={this.state.Categories}
                                                        Category_Names={this.state.Category_names}
                                                        multiSearchSelectData={this.multiSearchSelectDataMet}
                                                        Category_keys={this.state.Category_keys}
                                                        //selected={this.state.stored_Cat}
                                                        selectedCategories={this.state.stored_Cat}
                                                        //apiCategories={apiCategories}
                                                        //receivedProps={this.props.received_props.entity_uuid}
                                                    />
                                                ) : null}
                                            </div>
                                        </div>
                                
                                    </div>
                                }

                                {/*                                
                                <div className="upload-Slides form-group">
                                    {
                                        descriptionLoader === false ?
                                        <React.Fragment>                                                   
                                            <button className="btn btn-draft" onClick={() => this.handleCancel()}>Cancel</button>
                                            <button className="btn btn-next">Save + Next</button>
                                        </React.Fragment>
                                        :
                                        <ActivityIndicator theme="button-Status-Loader" />
                                    }
                                </div>
                                */}


                            </Form>
                        </Col>
                        <Col lg={6} className="pad0">
                            <div className="extra-info">
                                {!this.workspace_base_url ?
                                <p>
                                    Give your PK a title and description, followed by a few
                                    categories. These will be publicly viewable and help us show
                                    your PK to users who love the same things you do!
                                </p>
                                :
                                <p>
                                    Give your PK a title and description. These will be viewable to anybody in your workspace.
                                </p>
                                }
                            </div>
                          { user_access_level === 'admin' &&  
                          <Container style={{ marginTop: "30px", marginBottom: "0px" }}>
                            
                              <Row className="justify-content-center" style={{ marginLeft: "20px", marginRight: "20px" }}>
                                <Col xs={12}>
                                  <Form.Group>
                                      <Form.Label>Select a Custom Cover Image File</Form.Label>
                                      <Form.File
                                        id={"pptx-to-slides-upload"}
                                        custom={true}
                                        disabled={this.state.image_uploading}
                                      >
                                      
                                        <Form.File.Input
                                          title={this.state.cover_image_file || 'Click to Select Image File'} // this handles the mouseover tooltip better
                                          //disabled={!this.state.editing || this.state.loading}
                                          onChange={this.onChangeCoverImageFile}
                                          //isInvalid={this.state.validated && !this.state.pptx_to_slides_file}
                                          accept={['jpg', 'jpeg', 'png', 'gif']}
                                          //ref={this.uploadPptxFileRef}
                                        />
                                        <Form.File.Label>{this.state.cover_image_file || 'Click to Select Image File'}</Form.File.Label>
                                        <Form.Control.Feedback type="invalid">Image file is required</Form.Control.Feedback>
                                      </Form.File>
                                    
                                  </Form.Group>
                                </Col>

                              </Row>
                              { this.state.cover_image_url &&
                              <Row className="justify-content-center">
                                <img wdidth='480px' height='270px' src={this.state.cover_image_url}/>
                              </Row>
                              }
                          </Container>                    
                          }
                            
                        </Col>
                    </Row>
                    
                    <div className="form-group btn-position">
                        {
                            descriptionLoader === false ?
                            <React.Fragment>                                                   
                                <button
                                    className="btn btn-draft"
                                    onClick={() => this.handleCancel()}
                                >
                                    Cancel
                                </button>
                                <button 
                                    className="btn btn-next"
                                    //onClick={() =>{ this.form_ref.current.dispatchEvent(new window.Event('submit')) }}
                                    form="main-form"
                                >
                                    Save + Next
                                </button>
                            </React.Fragment>
                            :
                            <ActivityIndicator theme="button-Status-Loader" />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(PresentationDescription);
